<template>
<div>
  <div class="obs-box" style="">
    <div class="img-box"
        v-for="(img, idx) in iObs.imgList" :key="idx">
      <div class="desc-top">{{img.desc}}</div>
      <div class="desc-bottom">{{img.desc}}</div>
      <img
        ref="imgEls"
        :src="img.src"
        @load="addIntersectionObs"
      >
    </div>
  </div>

  <div>
    <div>{{$Device.deviceInfo()}}</div>
    <div v-if="$isBrowserAvailable([['chrome', 69], ['safari', 16.4]])">
      <span>이 브라우저에서 사용할 수 있습니다.</span>
    </div>
    <div v-else>
      <span>이 브라우저에서 사용할 수 없습니다.</span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'WebEtcTest',
  created() {
    window.$ve = this;
    document.title += 'web etc test';
  },
  mounted() {
    this.createIntersectionObserver();
  },
  data () {
    return {
      iObs: {
        imgList: (() => {
          return [
            'https://cdn.shopify.com/s/files/1/1061/1924/files/Hugging_Face_Emoji_2028ce8b-c213-4d45-94aa-21e1a0842b4d_large.png?15202324258887420558',
            'https://freesvgs.com/wp-content/uploads/2021/06/Pikachu-SVG-File-Free.png',
            'https://cdn.pixabay.com/photo/2022/12/11/04/11/thumbs-up-7648171_1280.png',
            'https://clipart-library.com/images/dT4oReB7c.jpg',
            'https://clipart-library.com/newimages/free-emoji-clipart-5.jpg',
          ].map((src, idx) => {
            return {
              idx,
              src,
              desc: ''
            }
          });
        })()
      }
    }
  },

  methods: {
    async createIntersectionObserver () {
      if(this.iObs.obs) return;

      this.iObs.obs = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          this.intersecting(entry);
        });
      }, {
        rootMargin: '0px',
        threshold: 0.3
      });

      this.$refs.imgEls.forEach(el => this.addIntersectionObs(el));
    },
    async intersecting (entry) {
      const {target, isIntersecting, intersectionRatio} = entry;

      const imgObj = this.iObs.imgList.find(img => img.src === target.src);
      if(!imgObj){
        console.warn('not found:', isIntersecting, intersectionRatio, target.src, entry);
        return;
      }
      imgObj.desc = `[${imgObj.idx}]: is[${isIntersecting}], ratio[${(intersectionRatio*100).toFixed(2)}]`;
    },
    async addIntersectionObs (el) {
      if(el instanceof Event){
        el = el.target;
      }
      this.iObs.obs.observe(el);
    },
  }
}
</script>

<style scoped lang="scss">
.obs-box {
  width: 600px;
  height: 300px;
  overflow: scroll;
  border: 1px solid #000;

  .img-box {
    width: 300px;
    height: 300px;
    position: relative;
    border: 1px solid #ccc;

    .desc-top, .desc-bottom {
      position: absolute;
      left: 0px;
      top: 0px;
      font-size: 12px;
      text-shadow: 1px 1px #fff;
      background-color: #dfdfdf82;
      height: max-content;
    }
    .desc-bottom {
      top: unset;
      bottom: 0px;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>